import { useEffect } from "react";

import { useEngineStore } from "@/store/useEngineStore";

export function useAgentSync() {
  useEffect(() => {
    useEngineStore.getState().initializeAgent({
      agent: {
        id: "claw-1",
        name: "My Claw",
        position: [2.5, 0.5, 4],
        rotation: 12,
        currentAnimation: "Idle_A",
        targetPosition: null,
        path: [],
        pathIndex: 0,
        status: "idle",
        speed: 0,
      },
    });
  }, []);

  return { isConnected: true };
}
